export const SportIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.88449 3.2781C3.81787 3.44307 3.76 3.61073 3.71087 3.78039C3.98309 3.86367 4.26142 3.95607 4.54119 4.05847C4.69986 3.49305 4.97466 2.95331 5.36559 2.47682L8.13348 5.24112L7.61303 5.76089C7.73048 5.86197 7.84436 5.96716 7.95397 6.07662C8.05073 6.17325 8.1441 6.27317 8.2342 6.3759L8.75197 5.8588L11.5199 8.62317C11.047 9.01015 10.5119 9.28319 9.95118 9.44228C10.0534 9.72165 10.1455 9.99971 10.2282 10.2718C10.4241 10.2147 10.6172 10.1459 10.8066 10.0655C11.3721 9.82504 11.8866 9.48826 12.3297 9.07582C12.3746 9.03391 12.419 8.99107 12.4629 8.94729C12.5067 8.9035 12.5496 8.85914 12.5916 8.81422C13.005 8.3713 13.3425 7.85677 13.5834 7.29131C14.0436 6.20849 14.1225 5.00249 13.8201 3.87742C13.3361 2.07914 11.9184 0.662609 10.1177 0.179242C9.72136 0.0729883 9.31458 0.014201 8.90704 0.00224358C8.85554 0.000751296 8.80385 0 8.75199 0C8.69869 0 8.64557 0.00079374 8.59264 0.00237003C7.97841 0.0208863 7.36681 0.146505 6.78832 0.379228C5.46996 0.910818 4.4173 1.96172 3.88449 3.2781ZM12.8101 3.60988C12.2519 3.97964 11.5281 3.99568 10.9556 3.658L12.1383 2.47682C12.4244 2.82554 12.6484 3.20814 12.8101 3.60988ZM10.3238 4.28898C11.1324 4.86448 12.1945 4.92711 13.0582 4.47686C13.2745 5.69849 12.9679 6.99439 12.1384 8.00548L9.37045 5.24112L10.3238 4.28898ZM9.70535 3.6713L8.75197 4.62344L5.98408 1.85915C6.99646 1.03074 8.29399 0.724525 9.51718 0.9405C9.06638 1.80313 9.1291 2.86377 9.70535 3.6713ZM10.3371 3.04032C9.99902 2.46856 10.0151 1.74574 10.3853 1.18833C10.7876 1.34982 11.1707 1.57342 11.5199 1.85915L10.3371 3.04032ZM3.63204 7.98975C3.80283 7.81918 4.07974 7.81918 4.25053 7.98975L5.99987 9.73682C6.17066 9.90739 6.17066 10.1839 5.99987 10.3545C5.82908 10.5251 5.55218 10.5251 5.38139 10.3545L3.63204 8.60744C3.46125 8.43687 3.46125 8.16032 3.63204 7.98975ZM0.0413854 6.0109C-0.209992 4.91602 0.721135 3.96736 1.82256 4.19833C2.62018 4.36558 3.63101 4.62765 4.62066 5.02423C5.60575 5.41898 6.59861 5.95826 7.33547 6.69416C8.07415 7.43188 8.61109 8.42347 9.00146 9.40589C9.39361 10.3928 9.64907 11.3993 9.81041 12.1917C10.033 13.2846 9.09103 14.2048 8.0021 13.9603C6.46739 13.6156 4.03801 12.8815 2.58907 11.4344C1.14278 9.98999 0.395736 7.55428 0.0413854 6.0109ZM1.64282 5.05322C1.16676 4.95339 0.785062 5.34148 0.893933 5.81567C1.24669 7.35212 1.95317 9.56396 3.20756 10.8167C4.46354 12.0711 6.66759 12.7652 8.19398 13.108C8.66471 13.2137 9.04929 12.8373 8.95328 12.3657C8.79819 11.6041 8.5553 10.6513 8.18847 9.7281C7.81987 8.80049 7.33721 7.93127 6.71698 7.31184C6.09774 6.69341 5.22634 6.20817 4.29494 5.83493C3.3681 5.46353 2.4102 5.21414 1.64282 5.05322Z"
        fill="#959499"
      />
    </svg>
  );
};
export const DestinationIcon = () => {
  return (
    <svg
      width="12"
      height="15"
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 0C9.31371 0 12 2.68629 12 6C12 8.53516 10.2187 11.298 6.70166 14.3187C6.29809 14.6653 5.7019 14.6653 5.29672 14.3173L5.06426 14.1158C1.70284 11.1747 0 8.47865 0 6C0 2.68629 2.68629 0 6 0ZM6 0.923077C3.19609 0.923077 0.923077 3.19609 0.923077 6C0.923077 8.15511 2.49132 10.638 5.67049 13.4197L5.89975 13.6184C5.9574 13.6679 6.04258 13.6679 6.10024 13.6184C9.43319 10.7559 11.0769 8.20636 11.0769 6C11.0769 3.19609 8.80391 0.923077 6 0.923077ZM6 3.69231C7.2745 3.69231 8.30769 4.7255 8.30769 6C8.30769 7.2745 7.2745 8.30769 6 8.30769C4.7255 8.30769 3.69231 7.2745 3.69231 6C3.69231 4.7255 4.7255 3.69231 6 3.69231ZM6 4.61538C5.2353 4.61538 4.61538 5.2353 4.61538 6C4.61538 6.7647 5.2353 7.38461 6 7.38461C6.7647 7.38461 7.38462 6.7647 7.38462 6C7.38462 5.2353 6.7647 4.61538 6 4.61538Z"
        fill="#959499"
      />
    </svg>
  );
};
export const TravelIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 0C12.8807 0 14 1.11929 14 2.5V11.5C14 12.8807 12.8807 14 11.5 14H2.5C1.11929 14 0 12.8807 0 11.5V2.5C0 1.11929 1.11929 0 2.5 0H11.5ZM13 4H1V11.5C1 12.3284 1.67157 13 2.5 13H11.5C12.3284 13 13 12.3284 13 11.5V4ZM11.5 1H2.5C1.67157 1 1 1.67157 1 2.5V3H13V2.5C13 1.67157 12.3284 1 11.5 1Z"
        fill="#959499"
      />
    </svg>
  );
};
export const SearchIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.86111 0C13.755 0 17.7222 3.96725 17.7222 8.86111C17.7222 10.9778 16.98 12.9212 15.7417 14.4452L21.7315 20.4352C22.0895 20.7931 22.0895 21.3735 21.7315 21.7315C21.4061 22.057 20.8968 22.0865 20.538 21.8203L20.4352 21.7315L14.4452 15.7417C12.9212 16.98 10.9778 17.7222 8.86111 17.7222C3.96725 17.7222 0 13.755 0 8.86111C0 3.96725 3.96725 0 8.86111 0ZM8.86111 1.83333C4.97978 1.83333 1.83333 4.97978 1.83333 8.86111C1.83333 12.7424 4.97978 15.8889 8.86111 15.8889C12.7424 15.8889 15.8889 12.7424 15.8889 8.86111C15.8889 4.97978 12.7424 1.83333 8.86111 1.83333Z"
        fill="white"
      />
    </svg>
  );
};
